<template>
  <div class="overflow-auto">
    <template v-for="message in messages" :key="message.id">
      <MessageBubble class="w-100" :message="message"></MessageBubble>
    </template>
    <BCard v-if="isWaitingForAIResponse" bg-variant="light" class="loading-bubble-card float-start m-3 w-20">
      <div class="loading-bubble"></div>
    </BCard>
  </div>
</template>
<script>
import MessageBubble from './MessageBubble.vue';

export default {
  name: 'MessageList',
  components: {
    MessageBubble,
  },
    // single message: id, role, text, createdAt
  props: {
    isWaitingForAIResponse: {
      type: Boolean,
      required: true,
    },
    messages: {
      type: Array,
      required: true,
    },
  },
};
</script>


<style scoped>
  .loading-bubble {
    width: 60px;
    aspect-ratio: 5;
    background: radial-gradient(circle closest-side,#000 90%,#0000) 0/calc(100%/3) 100% space;
    clip-path: inset(0 100% 0 0);
    animation: l1 1s steps(4) infinite;
  }
  @keyframes l1 {to{clip-path: inset(0 -34% 0 0)}}
</style>